import UILink from 'UIComponents/link/UILink';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';

/* NOTE: There's no reference-resolver or reference-resolver-lite type for FEEDBACK_SURVEY, so fetch
using recommended endpoint from the feedback BE.
More info: https://hubspot.slack.com/archives/C0DS5D8JF/p1740002729053079?thread_ts=1739891494.457799&cid=C0DS5D8JF */

// No service types for this endpoint, so only fetch relevant data and assume it can be undefined
import { jsx as _jsx } from "react/jsx-runtime";
const GET_CUSTOM_FEEDBACK_SURVEY = registerQuery({
  fieldName: 'automation_customFeedbackSurvey',
  args: ['surveyId'],
  fetcher({
    surveyId
  }) {
    return http.get(`/feedback/v1/custom-survey/${surveyId}`);
  }
});
const FEEDBACK_SURVEY_REFERENCE_ID = /^CUSTOM_(\d)+$/;
const FeedbackSurveyName = ({
  surveyReferenceId,
  href
}) => {
  var _data$automation_cust;
  const [, maybeSurveyId] = (surveyReferenceId || '').split('_');
  const isInvalidSurveyId = surveyReferenceId === undefined || !FEEDBACK_SURVEY_REFERENCE_ID.test(surveyReferenceId) || !maybeSurveyId;
  const {
    data,
    loading
  } = useQuery(GET_CUSTOM_FEEDBACK_SURVEY, {
    variables: {
      surveyId: maybeSurveyId,
      skip: isInvalidSurveyId
    }
  });

  // taken from BusinessUnitName
  if (isInvalidSurveyId) {
    return /*#__PURE__*/_jsx("span", {
      children: '--'
    });
  }
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  const surveyName = (data === null || data === void 0 || (_data$automation_cust = data.automation_customFeedbackSurvey) === null || _data$automation_cust === void 0 || (_data$automation_cust = _data$automation_cust.customSurvey) === null || _data$automation_cust === void 0 ? void 0 : _data$automation_cust.surveyName) ||
  // fallback
  surveyReferenceId;
  return href ? /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: href,
    children: surveyName
  }) : /*#__PURE__*/_jsx("span", {
    children: surveyName
  });
};
export default FeedbackSurveyName;